import gql from 'graphql-tag';

export default gql`
  query availableVouchersForStore(
    $storeId: Int!
    $storeUuid: String!
    $buyerId: Int
    $draftOrderId: String
    $cartTotal: Float
    $itemUuids: [String]
  ) {
    availableVouchersForStore(
      input: {
        storeId: $storeId
        storeUuid: $storeUuid
        buyerId: $buyerId
        draftOrderId: $draftOrderId
        cartTotal: $cartTotal
        itemUuids: $itemUuids
      }
    ) {
      data {
        id
        code
        nameVn
        nameEn
        discountMinPrice
        discountPercent
        discountMaxValue
        startDate
        endDate
        isDisabled
      }
    }
  }
`;
